import { CustomElement } from '@aurelia/runtime-html';
export const name = "removed-team";
export const template = "<template >\n  <span class=\"team\"  style.bind=\"'border:1px; border-style: solid; padding: 5px; background-color:' + model.color\" draggable=\"true\" dragstart.trigger=\"model.dragTeam($event)\" drop.trigger=\"model.dropTeam($event)\" dragover.trigger=\"model.allow($event)\">${model.teamName} <sup>${model.gamesLeft}</sup></span>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {"model":{"name":"model"}};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
